import React, { useState } from "react";
import "./UpdateAgenda.css";

const UpdateAgenda = () => {

  return (
    <div>
      <h3>Update Agenda</h3>
      <p>Coming soon: Modify your meeting agenda here.</p>
    </div>
  );
};

export default UpdateAgenda;
